
import { Record, Union } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { lambda_type, unit_type, class_type, anonRecord_type, record_type, bool_type, list_type, option_type, float64_type, string_type, union_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { ImageUpload, DnDFormImage, DnDFormImage_$reflection } from "../Image/ImageUploadDnD.js";
import { length, sortBy, toArray as toArray_1, exists, tryHead, collect, cons, find, choose, append as append_1, max, tryFind, sumBy, contains, ofArray, singleton as singleton_1, empty, filter, isEmpty, map, tryPick } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { join, concat } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { FSharpMap__get_IsEmpty, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Map.js";
import { FormState__getValidation, FormState__startLoading, StorageId, FormState__setValidationResponse_5219762A, ToolId__get_unwrap, RequestedValue$1, FormState_get_empty, RequestedValue$1_$reflection, TokenDataDto_$reflection, FormState_$reflection, ClientApiResponse$1_$reflection, ValidationResponseModule_affectsAnyOf } from "../../Shared/Shared.js";
import { RolePermissionsDto_$reflection, Permission, Permissions_allowsInStorage } from "../../Shared/Roles.js";
import { unwrapConsumableId, unwrapStorageId } from "../../Shared/Helper.js";
import { FileUploadResponse_$reflection } from "../../Shared/File.js";
import { Helper_receiverTypeNameTranslation, ReceiverTypeName, Receiver_$reflection } from "../../Shared/User.js";
import { DataTransfer_DetailSet_$reflection } from "../../Shared/Set.js";
import { Helper_unitToTranslationKey, Helper_currentReceiverStock, Consumable_$reflection } from "../../Shared/Consumable.js";
import { Helper_quantityAsStringWithComma, Helper_toolId, ToolTypes_$reflection } from "../../Shared/Tool.js";
import { Storage__get_DisplayName, Storage_$reflection } from "../../Shared/Storage.js";
import { MultiUnassignToolWithQuantityDto, MultiUnassignConsumableDto, MultiUnassignSetDto, MultiUnassignToolDto, MultiUnassignDto, MultiUnassignDto_$reflection } from "../../Shared/MultiOperation.js";
import { Cmd_none, Cmd_ofEffect, Cmd_batch } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { iterate, toArray, empty as empty_1, singleton, append, delay, toList as toList_1 } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { getSelectedSets } from "../../Requests/Set.js";
import { Cmd_getSelectedConsumables } from "../../Requests/Consumable.js";
import { Cmd_getSelectedTools } from "../../Requests/Tool.js";
import { Cmd_OfPromise_either } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { fetchWithDecoder, addPrefix } from "../../CommunicationV2.js";
import { Types_RequestProperties } from "../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { ValidationOnGetRequest } from "../../ErrorHandling.js";
import { addPrefix as addPrefix_1, fetchWithDecoder as fetchWithDecoder_1 } from "../../Communication.js";
import { Cmd_successToast, Cmd_errorToast } from "../../Components/Toast.js";
import { createObj, int32ToString, safeHash, equals, comparePrimitives, stringHash } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { bind, toArray as toArray_2, flatten, unwrap, orElseWith, map as map_1, defaultArg } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { Cmd_uploadImage } from "../../Requests/Files.js";
import { parse, newGuid } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "../../fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { BlockHeader, InvalidTextValue } from "../../Components/Text.js";
import { ColumnDefinition$1, CellContent } from "../Table/Types.js";
import { NumberInput } from "../../Components/Input.js";
import { numberInputIntMaxValue } from "../../Common.js";
import { List_groupBy } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq2.js";
import { Select, GroupedSelect } from "../../Components/Select.js";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { InfiniteTable } from "../Table/InfiniteTable.js";
import Recycle_Bin_1 from "../../../public/assets/icons/Recycle_Bin_1.svg";
import { TableControlElement$1, TableControl$1 } from "../Table/Table.js";
import { TabsMenu } from "../TabsMenu.js";
import { TextArea } from "../../Components/TextArea.js";
import { Button } from "../../Components/Button.js";
import { InformationAlert, ErrorAlert, WarningAlert } from "../../Components/Alert.js";
import { defaultOf } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { Checkbox } from "../../Components/Checkbox.js";
import { usePermissions } from "../../UserPermissions.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { whenOpen } from "../Helper.js";
import { ModalSheet } from "../../Components/ModalSheet.js";
import { Skeleton } from "../../Components/Skeleton.js";

export class TableElementType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Tool", "ToolWithQuantity", "Consumable", "Set"];
    }
}

export function TableElementType_$reflection() {
    return union_type("Widgets.Modals.MultiUnassignModal.TableElementType", [], TableElementType, () => [[], [], [], []]);
}

export class TableElement extends Record {
    constructor(Id, ElementId, Manufacturer, Model, Name, AdditionalName, InventoryNumber, QRCodeIds, Quanity, Type, Unit, SelectedStorageId, InitialStorageId, AvailableStorageIds, CurrentSelectedSenderId, AvailableSenderIds, NewState, ReceiverImageFiles, ImageUploading) {
        super();
        this.Id = Id;
        this.ElementId = ElementId;
        this.Manufacturer = Manufacturer;
        this.Model = Model;
        this.Name = Name;
        this.AdditionalName = AdditionalName;
        this.InventoryNumber = InventoryNumber;
        this.QRCodeIds = QRCodeIds;
        this.Quanity = Quanity;
        this.Type = Type;
        this.Unit = Unit;
        this.SelectedStorageId = SelectedStorageId;
        this.InitialStorageId = InitialStorageId;
        this.AvailableStorageIds = AvailableStorageIds;
        this.CurrentSelectedSenderId = CurrentSelectedSenderId;
        this.AvailableSenderIds = AvailableSenderIds;
        this.NewState = NewState;
        this.ReceiverImageFiles = ReceiverImageFiles;
        this.ImageUploading = ImageUploading;
    }
}

export function TableElement_$reflection() {
    return record_type("Widgets.Modals.MultiUnassignModal.TableElement", [], TableElement, () => [["Id", string_type], ["ElementId", string_type], ["Manufacturer", string_type], ["Model", string_type], ["Name", string_type], ["AdditionalName", string_type], ["InventoryNumber", string_type], ["QRCodeIds", string_type], ["Quanity", option_type(float64_type)], ["Type", TableElementType_$reflection()], ["Unit", string_type], ["SelectedStorageId", option_type(string_type)], ["InitialStorageId", option_type(string_type)], ["AvailableStorageIds", list_type(string_type)], ["CurrentSelectedSenderId", option_type(string_type)], ["AvailableSenderIds", list_type(string_type)], ["NewState", option_type(string_type)], ["ReceiverImageFiles", list_type(DnDFormImage_$reflection())], ["ImageUploading", bool_type]]);
}

const maxReceiverImages = 5;

function elementValidation(translate, formState, rowId) {
    return tryPick((tupledArg) => {
        const affectedProperty = tupledArg[0];
        if ((affectedProperty.startsWith(concat(rowId, ..."-")) && (affectedProperty !== concat(rowId, ..."-quantity"))) && (affectedProperty !== concat(rowId, ..."-receiver-stock"))) {
            return translate(tupledArg[1]);
        }
        else {
            return undefined;
        }
    }, toList(formState.Validations));
}

function validationToastKey(tableElements, validationResponse) {
    if (ValidationResponseModule_affectsAnyOf(map((_arg) => _arg.Id, tableElements), validationResponse)) {
        return "validation.toast_rows";
    }
    else {
        return "validation.toast";
    }
}

function isNotAssigned(tableElement) {
    if (tableElement.CurrentSelectedSenderId == null) {
        return isEmpty(tableElement.AvailableSenderIds);
    }
    else {
        return false;
    }
}

function isSenderMissing(tableElement) {
    if (tableElement.CurrentSelectedSenderId == null) {
        return !isEmpty(tableElement.AvailableSenderIds);
    }
    else {
        return false;
    }
}

function rebookableStorages(permissions, userId, storages) {
    return filter((storage) => Permissions_allowsInStorage(permissions, new Permission(7, []), userId, unwrapStorageId(storage.Id), storage.AssignedUserIds), storages);
}

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Unassign", "SetComment", "SetQuantity", "SetStorage", "SetStorageForAll", "ResetStorageChange", "SetSelectedReceiverFiles", "ReceiverImageUploaded", "SetNewState", "SetSelectedSender", "AddElement", "RemoveElement", "InitTableElements", "UnassignedResponse", "SetsFetched", "ConsumableFetched", "ToolsFetched", "ReceiversFetched", "StoragesFetched", "FetchError"];
    }
}

function Msg_$reflection() {
    return union_type("Widgets.Modals.MultiUnassignModal.Msg", [], Msg, () => [[], [["Item", string_type]], [["id", string_type], ["quantity", option_type(float64_type)]], [["id", string_type], ["storageId", option_type(string_type)]], [["storageId", option_type(string_type)]], [], [["id", string_type], ["files", list_type(DnDFormImage_$reflection())]], [["id", string_type], ["response", FileUploadResponse_$reflection()]], [["id", string_type], ["Item2", option_type(anonRecord_type(["label", string_type], ["value", string_type]))]], [["id", string_type], ["Item2", option_type(anonRecord_type(["label", string_type], ["value", Receiver_$reflection()]))]], [["id", string_type]], [["id", string_type]], [], [["Item", ClientApiResponse$1_$reflection(string_type)]], [["Item", list_type(DataTransfer_DetailSet_$reflection())]], [["Item", list_type(Consumable_$reflection())]], [["Item", list_type(ToolTypes_$reflection())]], [["Item", list_type(Receiver_$reflection())]], [["Item", list_type(Storage_$reflection())]], [["Item", class_type("System.Exception")]]]);
}

class State extends Record {
    constructor(FormState, SuccessCallback, OnClose, AllowStorageChange, UserData, Permissions, Receivers, Sets, Consumables, Storages, Tools, TableElements, RemovedElements, ToolWithQuantityReceiverStocks, ConsumableReceiverStocks, Dto, SenderId) {
        super();
        this.FormState = FormState;
        this.SuccessCallback = SuccessCallback;
        this.OnClose = OnClose;
        this.AllowStorageChange = AllowStorageChange;
        this.UserData = UserData;
        this.Permissions = Permissions;
        this.Receivers = Receivers;
        this.Sets = Sets;
        this.Consumables = Consumables;
        this.Storages = Storages;
        this.Tools = Tools;
        this.TableElements = TableElements;
        this.RemovedElements = RemovedElements;
        this.ToolWithQuantityReceiverStocks = ToolWithQuantityReceiverStocks;
        this.ConsumableReceiverStocks = ConsumableReceiverStocks;
        this.Dto = Dto;
        this.SenderId = SenderId;
    }
}

function State_$reflection() {
    return record_type("Widgets.Modals.MultiUnassignModal.State", [], State, () => [["FormState", FormState_$reflection()], ["SuccessCallback", lambda_type(unit_type, unit_type)], ["OnClose", lambda_type(unit_type, unit_type)], ["AllowStorageChange", bool_type], ["UserData", TokenDataDto_$reflection()], ["Permissions", RolePermissionsDto_$reflection()], ["Receivers", RequestedValue$1_$reflection(list_type(Receiver_$reflection()))], ["Sets", RequestedValue$1_$reflection(list_type(DataTransfer_DetailSet_$reflection()))], ["Consumables", RequestedValue$1_$reflection(list_type(Consumable_$reflection()))], ["Storages", RequestedValue$1_$reflection(list_type(Storage_$reflection()))], ["Tools", RequestedValue$1_$reflection(list_type(ToolTypes_$reflection()))], ["TableElements", list_type(TableElement_$reflection())], ["RemovedElements", list_type(TableElement_$reflection())], ["ToolWithQuantityReceiverStocks", list_type(anonRecord_type(["ReceiverId", string_type], ["Stock", string_type]))], ["ConsumableReceiverStocks", list_type(anonRecord_type(["ReceiverId", string_type], ["Stock", string_type]))], ["Dto", MultiUnassignDto_$reflection()], ["SenderId", option_type(string_type)]]);
}

function init(successCallback, onClose, userData, permissions, senderId, allowStorageChange, unassignProps) {
    return [new State(FormState_get_empty(), successCallback, onClose, allowStorageChange, userData, permissions, new RequestedValue$1(0, []), isEmpty(unassignProps.SetIds) ? (new RequestedValue$1(1, [empty()])) : (new RequestedValue$1(0, [])), isEmpty(unassignProps.ConsumableIds) ? (new RequestedValue$1(1, [empty()])) : (new RequestedValue$1(0, [])), new RequestedValue$1(0, []), isEmpty(unassignProps.ToolIds) ? (new RequestedValue$1(1, [empty()])) : (new RequestedValue$1(0, [])), empty(), empty(), empty(), empty(), new MultiUnassignDto(empty(), empty(), empty(), empty(), ""), senderId), Cmd_batch(toList_1(delay(() => append(!isEmpty(unassignProps.SetIds) ? singleton(getSelectedSets(unassignProps.SetIds, (Item) => (new Msg(14, [Item])), (Item_1) => (new Msg(19, [Item_1])))) : empty_1(), delay(() => append(!isEmpty(unassignProps.ConsumableIds) ? singleton(Cmd_getSelectedConsumables(unassignProps.ConsumableIds, (Item_2) => (new Msg(15, [Item_2])), (Item_3) => (new Msg(19, [Item_3])))) : empty_1(), delay(() => append(!isEmpty(unassignProps.ToolIds) ? singleton(Cmd_getSelectedTools(map(ToolId__get_unwrap, unassignProps.ToolIds), (Item_4) => (new Msg(16, [Item_4])), (Item_5) => (new Msg(19, [Item_5])))) : empty_1(), delay(() => {
        let businessUnitId;
        return append(singleton((businessUnitId = undefined, Cmd_OfPromise_either((url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            let url_2;
            return ((url_2 = addPrefix(url), (refreshOn) => fetchWithDecoder(url_2, singleton_1(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
                const pr = response.arrayBuffer();
                return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), list_type(Receiver_$reflection())));
            }, refreshOn)))(true).then((_arg) => {
                const result_1 = _arg;
                return (result_1.tag === 1) ? (Promise.resolve((() => {
                    throw new ValidationOnGetRequest(result_1.fields[0]);
                })())) : (Promise.resolve(result_1.fields[0]));
            });
        })), concat("/api/receivers/active", ...((businessUnitId == null) ? "?businessUnitId=" : concat("?businessUnitId=", ...businessUnitId))), (Item_6) => (new Msg(17, [Item_6])), (Item_7) => (new Msg(19, [Item_7]))))), delay(() => singleton(Cmd_OfPromise_either((url_3) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetchWithDecoder_1(0, addPrefix_1(url_3), singleton_1(new Types_RequestProperties(0, ["GET"])), "application/json", (response_2) => {
            const pr_1 = response_2.arrayBuffer();
            return pr_1.then((blob_1) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_1)), list_type(Storage_$reflection())));
        })))), "/api/storages/access", (Item_8) => (new Msg(18, [Item_8])), (Item_9) => (new Msg(19, [Item_9]))))));
    })))))))))];
}

function update(msg, state) {
    let file_4, bind$0040_1, matchValue_3, senderId;
    switch (msg.tag) {
        case 13: {
            const response_2 = msg.fields[0];
            if (response_2.tag === 1) {
                const validationResponse = response_2.fields[0];
                return [new State(FormState__setValidationResponse_5219762A(state.FormState, validationResponse), state.SuccessCallback, state.OnClose, state.AllowStorageChange, state.UserData, state.Permissions, state.Receivers, state.Sets, state.Consumables, state.Storages, state.Tools, state.TableElements, state.RemovedElements, state.ToolWithQuantityReceiverStocks, state.ConsumableReceiverStocks, state.Dto, state.SenderId), Cmd_errorToast(validationToastKey(state.TableElements, validationResponse))];
            }
            else {
                return [new State(FormState_get_empty(), state.SuccessCallback, state.OnClose, state.AllowStorageChange, state.UserData, state.Permissions, state.Receivers, state.Sets, state.Consumables, state.Storages, state.Tools, state.TableElements, state.RemovedElements, state.ToolWithQuantityReceiverStocks, state.ConsumableReceiverStocks, state.Dto, state.SenderId), Cmd_batch(ofArray([Cmd_ofEffect((_arg) => {
                    state.SuccessCallback();
                }), Cmd_successToast("general.saved_successfully"), Cmd_ofEffect((_arg_1) => {
                    state.OnClose();
                })]))];
            }
        }
        case 3:
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.AllowStorageChange, state.UserData, state.Permissions, state.Receivers, state.Sets, state.Consumables, state.Storages, state.Tools, map((tableElement) => {
                if (tableElement.Id === msg.fields[0]) {
                    return new TableElement(tableElement.Id, tableElement.ElementId, tableElement.Manufacturer, tableElement.Model, tableElement.Name, tableElement.AdditionalName, tableElement.InventoryNumber, tableElement.QRCodeIds, tableElement.Quanity, tableElement.Type, tableElement.Unit, msg.fields[1], tableElement.InitialStorageId, tableElement.AvailableStorageIds, tableElement.CurrentSelectedSenderId, tableElement.AvailableSenderIds, tableElement.NewState, tableElement.ReceiverImageFiles, tableElement.ImageUploading);
                }
                else {
                    return tableElement;
                }
            }, state.TableElements), state.RemovedElements, state.ToolWithQuantityReceiverStocks, state.ConsumableReceiverStocks, state.Dto, state.SenderId), Cmd_none()];
        case 4: {
            const value_9 = msg.fields[0];
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.AllowStorageChange, state.UserData, state.Permissions, state.Receivers, state.Sets, state.Consumables, state.Storages, state.Tools, map((tableElement_1) => {
                const matchValue = tableElement_1.Type;
                let matchResult, storageId_1;
                switch (matchValue.tag) {
                    case 1:
                    case 2: {
                        matchResult = 0;
                        break;
                    }
                    default:
                        if (value_9 == null) {
                            matchResult = 3;
                        }
                        else if (contains(value_9, tableElement_1.AvailableStorageIds, {
                            Equals: (x_1, y) => (x_1 === y),
                            GetHashCode: (x_1) => (stringHash(x_1) | 0),
                        })) {
                            matchResult = 1;
                            storageId_1 = value_9;
                        }
                        else {
                            matchResult = 2;
                        }
                }
                switch (matchResult) {
                    case 0:
                        return tableElement_1;
                    case 1:
                        return new TableElement(tableElement_1.Id, tableElement_1.ElementId, tableElement_1.Manufacturer, tableElement_1.Model, tableElement_1.Name, tableElement_1.AdditionalName, tableElement_1.InventoryNumber, tableElement_1.QRCodeIds, tableElement_1.Quanity, tableElement_1.Type, tableElement_1.Unit, storageId_1, tableElement_1.InitialStorageId, tableElement_1.AvailableStorageIds, tableElement_1.CurrentSelectedSenderId, tableElement_1.AvailableSenderIds, tableElement_1.NewState, tableElement_1.ReceiverImageFiles, tableElement_1.ImageUploading);
                    case 2:
                        return tableElement_1;
                    default:
                        return new TableElement(tableElement_1.Id, tableElement_1.ElementId, tableElement_1.Manufacturer, tableElement_1.Model, tableElement_1.Name, tableElement_1.AdditionalName, tableElement_1.InventoryNumber, tableElement_1.QRCodeIds, tableElement_1.Quanity, tableElement_1.Type, tableElement_1.Unit, tableElement_1.InitialStorageId, tableElement_1.InitialStorageId, tableElement_1.AvailableStorageIds, tableElement_1.CurrentSelectedSenderId, tableElement_1.AvailableSenderIds, tableElement_1.NewState, tableElement_1.ReceiverImageFiles, tableElement_1.ImageUploading);
                }
            }, state.TableElements), state.RemovedElements, state.ToolWithQuantityReceiverStocks, state.ConsumableReceiverStocks, state.Dto, state.SenderId), Cmd_none()];
        }
        case 5:
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.AllowStorageChange, state.UserData, state.Permissions, state.Receivers, state.Sets, state.Consumables, state.Storages, state.Tools, map((tableElement_2) => {
                const matchValue_2 = tableElement_2.Type;
                switch (matchValue_2.tag) {
                    case 1:
                    case 2:
                        return tableElement_2;
                    default:
                        return new TableElement(tableElement_2.Id, tableElement_2.ElementId, tableElement_2.Manufacturer, tableElement_2.Model, tableElement_2.Name, tableElement_2.AdditionalName, tableElement_2.InventoryNumber, tableElement_2.QRCodeIds, tableElement_2.Quanity, tableElement_2.Type, tableElement_2.Unit, tableElement_2.InitialStorageId, tableElement_2.InitialStorageId, tableElement_2.AvailableStorageIds, tableElement_2.CurrentSelectedSenderId, tableElement_2.AvailableSenderIds, tableElement_2.NewState, tableElement_2.ReceiverImageFiles, tableElement_2.ImageUploading);
                }
            }, state.TableElements), state.RemovedElements, state.ToolWithQuantityReceiverStocks, state.ConsumableReceiverStocks, state.Dto, state.SenderId), Cmd_none()];
        case 6: {
            const newFiles = msg.fields[1];
            const id_1 = msg.fields[0];
            const alreadyUploadedCount = defaultArg(map_1((element_10) => (sumBy((file_1) => {
                if (file_1.tag === 0) {
                    return 0;
                }
                else {
                    return 1;
                }
            }, element_10.ReceiverImageFiles, {
                GetZero: () => 0,
                Add: (x_2, y_1) => ((x_2 + y_1) | 0),
            }) | 0), tryFind((tableElement_3) => (tableElement_3.Id === id_1), state.TableElements)), 0) | 0;
            const pickedFile = tryPick((file_2) => {
                if (file_2.tag === 1) {
                    return undefined;
                }
                else {
                    return file_2.fields[0].File;
                }
            }, newFiles);
            let matchResult_1, file_5;
            if (pickedFile != null) {
                if ((file_4 = pickedFile, alreadyUploadedCount < maxReceiverImages)) {
                    matchResult_1 = 0;
                    file_5 = pickedFile;
                }
                else {
                    matchResult_1 = 1;
                }
            }
            else {
                matchResult_1 = 1;
            }
            switch (matchResult_1) {
                case 0: {
                    const formData = new FormData();
                    formData.append(file_5.name, file_5);
                    return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.AllowStorageChange, state.UserData, state.Permissions, state.Receivers, state.Sets, state.Consumables, state.Storages, state.Tools, map((tableElement_4) => {
                        if (tableElement_4.Id === id_1) {
                            return new TableElement(tableElement_4.Id, tableElement_4.ElementId, tableElement_4.Manufacturer, tableElement_4.Model, tableElement_4.Name, tableElement_4.AdditionalName, tableElement_4.InventoryNumber, tableElement_4.QRCodeIds, tableElement_4.Quanity, tableElement_4.Type, tableElement_4.Unit, tableElement_4.SelectedStorageId, tableElement_4.InitialStorageId, tableElement_4.AvailableStorageIds, tableElement_4.CurrentSelectedSenderId, tableElement_4.AvailableSenderIds, tableElement_4.NewState, newFiles, true);
                        }
                        else {
                            return tableElement_4;
                        }
                    }, state.TableElements), state.RemovedElements, state.ToolWithQuantityReceiverStocks, state.ConsumableReceiverStocks, state.Dto, state.SenderId), Cmd_uploadImage((response_3) => (new Msg(7, [id_1, response_3])), (Item_2) => (new Msg(19, [Item_2])), formData)];
                }
                default:
                    return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.AllowStorageChange, state.UserData, state.Permissions, state.Receivers, state.Sets, state.Consumables, state.Storages, state.Tools, map((tableElement_5) => {
                        if (tableElement_5.Id === id_1) {
                            return new TableElement(tableElement_5.Id, tableElement_5.ElementId, tableElement_5.Manufacturer, tableElement_5.Model, tableElement_5.Name, tableElement_5.AdditionalName, tableElement_5.InventoryNumber, tableElement_5.QRCodeIds, tableElement_5.Quanity, tableElement_5.Type, tableElement_5.Unit, tableElement_5.SelectedStorageId, tableElement_5.InitialStorageId, tableElement_5.AvailableStorageIds, tableElement_5.CurrentSelectedSenderId, tableElement_5.AvailableSenderIds, tableElement_5.NewState, newFiles, tableElement_5.ImageUploading);
                        }
                        else {
                            return tableElement_5;
                        }
                    }, state.TableElements), state.RemovedElements, state.ToolWithQuantityReceiverStocks, state.ConsumableReceiverStocks, state.Dto, state.SenderId), Cmd_none()];
            }
        }
        case 7: {
            const response_4 = msg.fields[1];
            const updateElement = (mapper) => map((tableElement_6) => {
                if (tableElement_6.Id === msg.fields[0]) {
                    return mapper(tableElement_6);
                }
                else {
                    return tableElement_6;
                }
            }, state.TableElements);
            switch (response_4.tag) {
                case 0:
                    return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.AllowStorageChange, state.UserData, state.Permissions, state.Receivers, state.Sets, state.Consumables, state.Storages, state.Tools, updateElement((tableElement_8) => (new TableElement(tableElement_8.Id, tableElement_8.ElementId, tableElement_8.Manufacturer, tableElement_8.Model, tableElement_8.Name, tableElement_8.AdditionalName, tableElement_8.InventoryNumber, tableElement_8.QRCodeIds, tableElement_8.Quanity, tableElement_8.Type, tableElement_8.Unit, tableElement_8.SelectedStorageId, tableElement_8.InitialStorageId, tableElement_8.AvailableStorageIds, tableElement_8.CurrentSelectedSenderId, tableElement_8.AvailableSenderIds, tableElement_8.NewState, filter((file_8) => {
                        if (file_8.tag === 0) {
                            return false;
                        }
                        else {
                            return true;
                        }
                    }, tableElement_8.ReceiverImageFiles), false))), state.RemovedElements, state.ToolWithQuantityReceiverStocks, state.ConsumableReceiverStocks, state.Dto, state.SenderId), Cmd_errorToast("general.file_too_large")];
                case 2:
                    return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.AllowStorageChange, state.UserData, state.Permissions, state.Receivers, state.Sets, state.Consumables, state.Storages, state.Tools, updateElement((tableElement_9) => (new TableElement(tableElement_9.Id, tableElement_9.ElementId, tableElement_9.Manufacturer, tableElement_9.Model, tableElement_9.Name, tableElement_9.AdditionalName, tableElement_9.InventoryNumber, tableElement_9.QRCodeIds, tableElement_9.Quanity, tableElement_9.Type, tableElement_9.Unit, tableElement_9.SelectedStorageId, tableElement_9.InitialStorageId, tableElement_9.AvailableStorageIds, tableElement_9.CurrentSelectedSenderId, tableElement_9.AvailableSenderIds, tableElement_9.NewState, filter((file_9) => {
                        if (file_9.tag === 0) {
                            return false;
                        }
                        else {
                            return true;
                        }
                    }, tableElement_9.ReceiverImageFiles), false))), state.RemovedElements, state.ToolWithQuantityReceiverStocks, state.ConsumableReceiverStocks, state.Dto, state.SenderId), Cmd_errorToast("general.a_error_occured")];
                default:
                    return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.AllowStorageChange, state.UserData, state.Permissions, state.Receivers, state.Sets, state.Consumables, state.Storages, state.Tools, updateElement((tableElement_7) => {
                        const nextPosition = (1 + max(append_1(singleton_1(0), choose((file_6) => {
                            if (file_6.tag === 0) {
                                return undefined;
                            }
                            else {
                                return file_6.fields[0].Position;
                            }
                        }, tableElement_7.ReceiverImageFiles)), {
                            Compare: (x_3, y_2) => (comparePrimitives(x_3, y_2) | 0),
                        })) | 0;
                        return new TableElement(tableElement_7.Id, tableElement_7.ElementId, tableElement_7.Manufacturer, tableElement_7.Model, tableElement_7.Name, tableElement_7.AdditionalName, tableElement_7.InventoryNumber, tableElement_7.QRCodeIds, tableElement_7.Quanity, tableElement_7.Type, tableElement_7.Unit, tableElement_7.SelectedStorageId, tableElement_7.InitialStorageId, tableElement_7.AvailableStorageIds, tableElement_7.CurrentSelectedSenderId, tableElement_7.AvailableSenderIds, tableElement_7.NewState, append_1(filter((file_7) => {
                            if (file_7.tag === 0) {
                                return false;
                            }
                            else {
                                return true;
                            }
                        }, tableElement_7.ReceiverImageFiles), singleton_1(new DnDFormImage(1, [{
                            ImageUrl: response_4.fields[0].ImageUrl,
                            Position: nextPosition,
                        }]))), false);
                    }), state.RemovedElements, state.ToolWithQuantityReceiverStocks, state.ConsumableReceiverStocks, state.Dto, state.SenderId), Cmd_none()];
            }
        }
        case 2:
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.AllowStorageChange, state.UserData, state.Permissions, state.Receivers, state.Sets, state.Consumables, state.Storages, state.Tools, map((tableElement_10) => {
                if (tableElement_10.Id === msg.fields[0]) {
                    return new TableElement(tableElement_10.Id, tableElement_10.ElementId, tableElement_10.Manufacturer, tableElement_10.Model, tableElement_10.Name, tableElement_10.AdditionalName, tableElement_10.InventoryNumber, tableElement_10.QRCodeIds, msg.fields[1], tableElement_10.Type, tableElement_10.Unit, tableElement_10.SelectedStorageId, tableElement_10.InitialStorageId, tableElement_10.AvailableStorageIds, tableElement_10.CurrentSelectedSenderId, tableElement_10.AvailableSenderIds, tableElement_10.NewState, tableElement_10.ReceiverImageFiles, tableElement_10.ImageUploading);
                }
                else {
                    return tableElement_10;
                }
            }, state.TableElements), state.RemovedElements, state.ToolWithQuantityReceiverStocks, state.ConsumableReceiverStocks, state.Dto, state.SenderId), Cmd_none()];
        case 1:
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.AllowStorageChange, state.UserData, state.Permissions, state.Receivers, state.Sets, state.Consumables, state.Storages, state.Tools, state.TableElements, state.RemovedElements, state.ToolWithQuantityReceiverStocks, state.ConsumableReceiverStocks, (bind$0040_1 = state.Dto, new MultiUnassignDto(bind$0040_1.Tools, bind$0040_1.Sets, bind$0040_1.Consumables, bind$0040_1.ToolsWithQuantity, msg.fields[0])), state.SenderId), Cmd_none()];
        case 8:
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.AllowStorageChange, state.UserData, state.Permissions, state.Receivers, state.Sets, state.Consumables, state.Storages, state.Tools, map((tableElement_11) => {
                if (tableElement_11.Id === msg.fields[0]) {
                    return new TableElement(tableElement_11.Id, tableElement_11.ElementId, tableElement_11.Manufacturer, tableElement_11.Model, tableElement_11.Name, tableElement_11.AdditionalName, tableElement_11.InventoryNumber, tableElement_11.QRCodeIds, tableElement_11.Quanity, tableElement_11.Type, tableElement_11.Unit, tableElement_11.SelectedStorageId, tableElement_11.InitialStorageId, tableElement_11.AvailableStorageIds, tableElement_11.CurrentSelectedSenderId, tableElement_11.AvailableSenderIds, map_1((v) => v.value, msg.fields[1]), tableElement_11.ReceiverImageFiles, tableElement_11.ImageUploading);
                }
                else {
                    return tableElement_11;
                }
            }, state.TableElements), state.RemovedElements, state.ToolWithQuantityReceiverStocks, state.ConsumableReceiverStocks, state.Dto, state.SenderId), Cmd_none()];
        case 9:
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.AllowStorageChange, state.UserData, state.Permissions, state.Receivers, state.Sets, state.Consumables, state.Storages, state.Tools, map((tableElement_12) => {
                if (tableElement_12.Id === msg.fields[0]) {
                    return new TableElement(tableElement_12.Id, tableElement_12.ElementId, tableElement_12.Manufacturer, tableElement_12.Model, tableElement_12.Name, tableElement_12.AdditionalName, tableElement_12.InventoryNumber, tableElement_12.QRCodeIds, tableElement_12.Quanity, tableElement_12.Type, tableElement_12.Unit, tableElement_12.SelectedStorageId, tableElement_12.InitialStorageId, tableElement_12.AvailableStorageIds, map_1((value_15) => value_15.value.Id, msg.fields[1]), tableElement_12.AvailableSenderIds, tableElement_12.NewState, tableElement_12.ReceiverImageFiles, tableElement_12.ImageUploading);
                }
                else {
                    return tableElement_12;
                }
            }, state.TableElements), state.RemovedElements, state.ToolWithQuantityReceiverStocks, state.ConsumableReceiverStocks, state.Dto, state.SenderId), Cmd_none()];
        case 10: {
            const id_6 = msg.fields[0];
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.AllowStorageChange, state.UserData, state.Permissions, state.Receivers, state.Sets, state.Consumables, state.Storages, state.Tools, cons(find((tableElement_13) => (tableElement_13.Id === id_6), state.RemovedElements), state.TableElements), filter((tableElement_14) => (tableElement_14.Id !== id_6), state.RemovedElements), state.ToolWithQuantityReceiverStocks, state.ConsumableReceiverStocks, state.Dto, state.SenderId), Cmd_none()];
        }
        case 11: {
            const id_7 = msg.fields[0];
            const selectedElement_1 = find((tableElement_15) => (tableElement_15.Id === id_7), state.TableElements);
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.AllowStorageChange, state.UserData, state.Permissions, state.Receivers, state.Sets, state.Consumables, state.Storages, state.Tools, filter((tableElement_16) => (tableElement_16.Id !== id_7), state.TableElements), cons(selectedElement_1, state.RemovedElements), state.ToolWithQuantityReceiverStocks, state.ConsumableReceiverStocks, state.Dto, state.SenderId), Cmd_none()];
        }
        case 17: {
            const response_5 = msg.fields[0];
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.AllowStorageChange, state.UserData, state.Permissions, new RequestedValue$1(1, [(matchValue_3 = state.SenderId, (matchValue_3 == null) ? response_5 : ((senderId = matchValue_3, filter((receiver) => (receiver.Id === senderId), response_5))))]), state.Sets, state.Consumables, state.Storages, state.Tools, state.TableElements, state.RemovedElements, state.ToolWithQuantityReceiverStocks, state.ConsumableReceiverStocks, state.Dto, state.SenderId), singleton_1((dispatch) => {
                dispatch(new Msg(12, []));
            })];
        }
        case 18:
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.AllowStorageChange, state.UserData, state.Permissions, state.Receivers, state.Sets, state.Consumables, new RequestedValue$1(1, [msg.fields[0]]), state.Tools, state.TableElements, state.RemovedElements, state.ToolWithQuantityReceiverStocks, state.ConsumableReceiverStocks, state.Dto, state.SenderId), singleton_1((dispatch_1) => {
                dispatch_1(new Msg(12, []));
            })];
        case 14:
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.AllowStorageChange, state.UserData, state.Permissions, state.Receivers, new RequestedValue$1(1, [msg.fields[0]]), state.Consumables, state.Storages, state.Tools, state.TableElements, state.RemovedElements, state.ToolWithQuantityReceiverStocks, state.ConsumableReceiverStocks, state.Dto, state.SenderId), singleton_1((dispatch_2) => {
                dispatch_2(new Msg(12, []));
            })];
        case 15:
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.AllowStorageChange, state.UserData, state.Permissions, state.Receivers, state.Sets, new RequestedValue$1(1, [msg.fields[0]]), state.Storages, state.Tools, state.TableElements, state.RemovedElements, state.ToolWithQuantityReceiverStocks, state.ConsumableReceiverStocks, state.Dto, state.SenderId), singleton_1((dispatch_3) => {
                dispatch_3(new Msg(12, []));
            })];
        case 16:
            return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.AllowStorageChange, state.UserData, state.Permissions, state.Receivers, state.Sets, state.Consumables, state.Storages, new RequestedValue$1(1, [msg.fields[0]]), state.TableElements, state.RemovedElements, state.ToolWithQuantityReceiverStocks, state.ConsumableReceiverStocks, state.Dto, state.SenderId), singleton_1((dispatch_4) => {
                dispatch_4(new Msg(12, []));
            })];
        case 12: {
            const matchValue_4 = state.Consumables;
            const matchValue_5 = state.Tools;
            const matchValue_6 = state.Sets;
            const matchValue_7 = state.Storages;
            const matchValue_8 = state.Receivers;
            let matchResult_2, consumables, receivers, sets, storages, tools;
            if (matchValue_4.tag === 0) {
                matchResult_2 = 1;
            }
            else if (matchValue_5.tag === 0) {
                matchResult_2 = 1;
            }
            else if (matchValue_6.tag === 0) {
                matchResult_2 = 1;
            }
            else if (matchValue_7.tag === 0) {
                matchResult_2 = 1;
            }
            else if (matchValue_8.tag === 0) {
                matchResult_2 = 1;
            }
            else {
                matchResult_2 = 0;
                consumables = matchValue_4.fields[0];
                receivers = matchValue_8.fields[0];
                sets = matchValue_6.fields[0];
                storages = matchValue_7.fields[0];
                tools = matchValue_5.fields[0];
            }
            switch (matchResult_2) {
                case 0: {
                    const storageIds = map((storage) => storage.Id, storages);
                    const accessibleStorageIds = state.AllowStorageChange ? map((storage_1) => unwrapStorageId(storage_1.Id), rebookableStorages(state.Permissions, state.UserData.UserId, storages)) : empty();
                    const getStorageId = (storageId_2) => map_1((storage_3) => unwrapStorageId(storage_3.Id), tryFind((storage_2) => equals(storage_2.Id, storageId_2), storages));
                    const setElements = map((set$) => {
                        let matchValue_10, receiverId;
                        return new TableElement(newGuid(), set$.Id, set$.MasterData.Manufacturer, set$.MasterData.Model, set$.MasterData.Name, "", set$.MasterData.InventoryNumber, join(", ", map((_arg_2) => _arg_2.Value, filter((ai) => (ai.Kind === "qrCode"), set$.AssetIdentifiers))), undefined, new TableElementType(3, []), "piece", getStorageId(new StorageId(parse(set$.LocationInformation.StorageId))), getStorageId(new StorageId(parse(set$.LocationInformation.StorageId))), accessibleStorageIds, (matchValue_10 = set$.LocationInformation.AssignedReceiverId, (matchValue_10 == null) ? undefined : ((receiverId = matchValue_10, map_1((receiver_2) => receiver_2.Id, tryFind((receiver_1) => (receiver_1.Id === receiverId), receivers))))), empty(), undefined, empty(), false);
                    }, sets);
                    const setToolIds = map((tool) => tool.ToolId, collect((set$_1) => set$_1.AssignedTools, sets));
                    const toolElements = map((tool_2) => {
                        let matchValue_14, senderId_2, matchValue_11, receiverId_1;
                        if (tool_2.tag === 1) {
                            const tool_4 = tool_2.fields[0];
                            const availableStorageIds = map((sps_1) => unwrapStorageId(sps_1.StorageId), filter((sps) => contains(sps.StorageId, storageIds, {
                                Equals: equals,
                                GetHashCode: (x_6) => (safeHash(x_6) | 0),
                            }), tool_4.StockPerStorage));
                            const availableUserStocks = choose((ua_1) => {
                                const matchValue_12 = tryFind((receiver_5) => (receiver_5.Id === ua_1.UserId), receivers);
                                if (matchValue_12 == null) {
                                    return undefined;
                                }
                                else {
                                    const receiver_7 = matchValue_12;
                                    return ua_1.UserId;
                                }
                            }, filter((ua) => (ua.Quantity > 0), tool_4.UserAssignments));
                            let quantity;
                            const matchValue_13 = state.SenderId;
                            if (matchValue_13 != null) {
                                const senderId_1 = matchValue_13;
                                quantity = find((ua_2) => (ua_2.UserId === senderId_1), tool_4.UserAssignments).Quantity;
                            }
                            else {
                                quantity = 0;
                            }
                            return new TableElement(newGuid(), ToolId__get_unwrap(tool_4.Id), tool_4.Manufacturer, tool_4.Model, tool_4.DisplayName, "", tool_4.InventoryNumber, join(", ", collect((_arg_4) => _arg_4.QRCodeIds, tool_4.StockPerStorage)), quantity, new TableElementType(1, []), "piece", tryHead(availableStorageIds), tryHead(availableStorageIds), availableStorageIds, (matchValue_14 = state.SenderId, (matchValue_14 == null) ? tryHead(availableUserStocks) : ((senderId_2 = matchValue_14, map_1((receiver_9) => receiver_9.Id, tryFind((receiver_8) => (receiver_8.Id === senderId_2), receivers))))), map((x_7) => x_7, availableUserStocks), undefined, empty(), false);
                        }
                        else {
                            const tool_3 = tool_2.fields[0];
                            return new TableElement(newGuid(), ToolId__get_unwrap(tool_3.Id), tool_3.Manufacturer, tool_3.Model, tool_3.DisplayName, "", tool_3.InventoryNumber, join(", ", tool_3.QRCodeIds), undefined, new TableElementType(0, []), "piece", getStorageId(tool_3.StorageId), getStorageId(tool_3.StorageId), accessibleStorageIds, (matchValue_11 = tool_3.AssignedUserId, (matchValue_11 == null) ? undefined : ((receiverId_1 = matchValue_11, map_1((receiver_4) => receiver_4.Id, tryFind((receiver_3) => (receiver_3.Id === receiverId_1), receivers))))), empty(), undefined, empty(), false);
                        }
                    }, filter((tool_1) => !contains(ToolId__get_unwrap(Helper_toolId(tool_1)), setToolIds, {
                        Equals: (x_5, y_4) => (x_5 === y_4),
                        GetHashCode: (x_5) => (stringHash(x_5) | 0),
                    }), tools));
                    const consumableElements = map((consumable) => {
                        let matchValue_15, senderId_3;
                        const availableStorageIds_1 = map((sps_3) => unwrapStorageId(sps_3.StorageId), filter((sps_2) => contains(sps_2.StorageId, storageIds, {
                            Equals: equals,
                            GetHashCode: (x_8) => (safeHash(x_8) | 0),
                        }), consumable.StockPerStorage));
                        return new TableElement(newGuid(), unwrapConsumableId(consumable.Id), "", "", consumable.Name, consumable.AdditionalName, consumable.InventoryNumber, join(", ", collect((_arg_5) => _arg_5.QRCodeIds, consumable.StockPerStorage)), 0, new TableElementType(2, []), consumable.Unit, tryHead(availableStorageIds_1), tryHead(availableStorageIds_1), availableStorageIds_1, (matchValue_15 = state.SenderId, (matchValue_15 == null) ? undefined : ((senderId_3 = matchValue_15, map_1((receiver_11) => receiver_11.Id, tryFind((receiver_10) => (receiver_10.Id === senderId_3), receivers))))), map((receiver_12) => receiver_12.Id, receivers), undefined, empty(), false);
                    }, consumables);
                    const toolWithQuantityReceiverStocks = collect((x_9) => x_9, choose((tool_5) => {
                        if (tool_5.tag === 1) {
                            return map((ua_5) => ({
                                ReceiverId: ua_5.UserId,
                                Stock: int32ToString(ua_5.Quantity),
                            }), filter((ua_4) => (ua_4.Quantity > 0), tool_5.fields[0].UserAssignments));
                        }
                        else {
                            return undefined;
                        }
                    }, tools));
                    const consumableReceiverStocks = collect((x_10) => x_10, map((receiver_13) => map((consumable_1) => ({
                        ReceiverId: receiver_13.Id,
                        Stock: Helper_quantityAsStringWithComma(Helper_currentReceiverStock(receiver_13.Id, consumable_1.Events)),
                    }), consumables), receivers));
                    return [new State(state.FormState, state.SuccessCallback, state.OnClose, state.AllowStorageChange, state.UserData, state.Permissions, state.Receivers, state.Sets, state.Consumables, state.Storages, state.Tools, append_1(setElements, append_1(toolElements, consumableElements)), state.RemovedElements, toolWithQuantityReceiverStocks, consumableReceiverStocks, state.Dto, state.SenderId), Cmd_none()];
                }
                default:
                    return [state, Cmd_none()];
            }
        }
        case 19:
            return [new State(FormState_get_empty(), state.SuccessCallback, state.OnClose, state.AllowStorageChange, state.UserData, state.Permissions, state.Receivers, state.Sets, state.Consumables, state.Storages, state.Tools, state.TableElements, state.RemovedElements, state.ToolWithQuantityReceiverStocks, state.ConsumableReceiverStocks, state.Dto, state.SenderId), Cmd_errorToast("general.a_error_occured")];
        default: {
            const receiverImageUrls = (element) => choose((file) => {
                if (file.tag === 0) {
                    return undefined;
                }
                else {
                    return file.fields[0].ImageUrl;
                }
            }, element.ReceiverImageFiles);
            const updatedDto = new MultiUnassignDto(map((element_2) => (new MultiUnassignToolDto(element_2.Id, element_2.ElementId, element_2.NewState, state.AllowStorageChange ? element_2.SelectedStorageId : undefined, receiverImageUrls(element_2))), filter((element_1) => equals(element_1.Type, new TableElementType(0, [])), state.TableElements)), map((element_4) => (new MultiUnassignSetDto(element_4.Id, element_4.ElementId, element_4.NewState, state.AllowStorageChange ? element_4.SelectedStorageId : undefined, receiverImageUrls(element_4))), filter((element_3) => equals(element_3.Type, new TableElementType(3, [])), state.TableElements)), map((element_6) => (new MultiUnassignConsumableDto(element_6.Id, element_6.ElementId, defaultArg(element_6.Quanity, 0), defaultArg(element_6.SelectedStorageId, ""), defaultArg(element_6.CurrentSelectedSenderId, ""), receiverImageUrls(element_6))), filter((element_5) => equals(element_5.Type, new TableElementType(2, [])), state.TableElements)), map((element_8) => (new MultiUnassignToolWithQuantityDto(element_8.Id, element_8.ElementId, defaultArg(map_1((value_3) => (~~value_3 | 0), element_8.Quanity), 0), defaultArg(element_8.SelectedStorageId, ""), defaultArg(element_8.CurrentSelectedSenderId, ""), receiverImageUrls(element_8))), filter((element_7) => equals(element_7.Type, new TableElementType(1, [])), state.TableElements)), state.Dto.Comment);
            return [new State(FormState__startLoading(state.FormState), state.SuccessCallback, state.OnClose, state.AllowStorageChange, state.UserData, state.Permissions, state.Receivers, state.Sets, state.Consumables, state.Storages, state.Tools, state.TableElements, state.RemovedElements, state.ToolWithQuantityReceiverStocks, state.ConsumableReceiverStocks, state.Dto, state.SenderId), Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                let url_2;
                return ((url_2 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_2, ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response) => {
                    const pr = response.arrayBuffer();
                    return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), string_type));
                }, refreshOn)))(true);
            })), ["/api/multi-operations/unassign", toString(0, Auto_generateBoxedEncoder_437914C6(MultiUnassignDto_$reflection(), undefined, undefined, undefined)(updatedDto))], (Item) => (new Msg(13, [Item])), (Item_1) => (new Msg(19, [Item_1])))];
        }
    }
}

function Table(props) {
    let elems_2;
    const patternInput = useTranslation();
    const t = patternInput[0];
    const i18n = patternInput[1];
    const containsConsumables = exists((tableElement) => equals(tableElement.Type, new TableElementType(2, [])), props.TableElements);
    const componentState = props.FormState.IsLoading ? "disabled" : "enabled";
    const hasRowWithoutSender = exists((tableElement_1) => {
        if (isNotAssigned(tableElement_1)) {
            return true;
        }
        else {
            return isSenderMissing(tableElement_1);
        }
    }, props.TableElements);
    const columnDefinition = toArray(delay(() => append((!FSharpMap__get_IsEmpty(props.FormState.Validations) ? true : hasRowWithoutSender) ? singleton(new ColumnDefinition$1("hint", "", t("assign_multiple_tools_dialog.hint"), (row) => {
        let Text$, Text$_1;
        const matchValue = elementValidation(t, props.FormState, row.Id);
        if (matchValue == null) {
            return isNotAssigned(row) ? (new CellContent(2, [createElement(InvalidTextValue, (Text$ = t("multi_operation.unassign.not_assigned"), {
                TestId: concat(row.Id, ..."-validation-message"),
                Text: Text$,
            }))])) : (isSenderMissing(row) ? (new CellContent(2, [createElement(InvalidTextValue, (Text$_1 = t("multi_operation.unassign.sender_missing"), {
                TestId: concat(row.Id, ..."-validation-message"),
                Text: Text$_1,
            }))])) : (new CellContent(0, [""])));
        }
        else {
            const value = matchValue;
            return new CellContent(2, [createElement(InvalidTextValue, {
                TestId: concat(row.Id, ..."-validation-message"),
                Text: value,
            })]);
        }
    }, "none", "text")) : empty_1(), delay(() => append(singleton(new ColumnDefinition$1("manufacturer", "", t("assign_multiple_tools_dialog.manufacturer"), (row_1) => (new CellContent(0, [row_1.Manufacturer])), "none", "text")), delay(() => append(singleton(new ColumnDefinition$1("model", "", t("assign_multiple_tools_dialog.model"), (row_2) => (new CellContent(0, [row_2.Model])), "none", "text")), delay(() => append(containsConsumables ? singleton(new ColumnDefinition$1("additionalName", "", t("consumable.additional_name"), (row_3) => (new CellContent(0, [row_3.AdditionalName])), "none", "text")) : empty_1(), delay(() => append(singleton(new ColumnDefinition$1("name", "", t("tool.displayname"), (row_4) => (new CellContent(0, [row_4.Name])), "none", "text")), delay(() => append(singleton(new ColumnDefinition$1("inventoryNumber", "", t("assign_multiple_tools_dialog.inventory_number"), (row_5) => (new CellContent(0, [row_5.InventoryNumber])), "none", "text")), delay(() => append(singleton(new ColumnDefinition$1("qrCodeIds", "", t("general.qr_code"), (row_6) => (new CellContent(0, [row_6.QRCodeIds])), "none", "text")), delay(() => append(singleton(new ColumnDefinition$1("quantity", "", t("general.quantity_3"), (row_7) => {
        let Value_1, ValidationMessage_1, Value, ValidationMessage;
        const matchValue_1 = row_7.Type;
        switch (matchValue_1.tag) {
            case 1:
                return new CellContent(2, [createElement(NumberInput, (Value_1 = map_1((value_3) => value_3, row_7.Quanity), (ValidationMessage_1 = orElseWith(FormState__getValidation(props.FormState, t, concat(row_7.Id, ..."-quantity")), () => FormState__getValidation(props.FormState, t, concat(row_7.Id, ..."-receiver-stock"))), {
                    ComponentState: componentState,
                    MaxValue: numberInputIntMaxValue,
                    OnChange: (value_4) => {
                        props.Dispatch(new Msg(2, [row_7.Id, value_4]));
                    },
                    TestId: concat("multi-unassign-", row_7.Id, ..."-quantity-input"),
                    ValidationMessage: unwrap(ValidationMessage_1),
                    Value: unwrap(Value_1),
                })))]);
            case 0:
            case 3:
                return new CellContent(0, ["1"]);
            default:
                return new CellContent(2, [createElement(NumberInput, (Value = map_1((value_1) => value_1, row_7.Quanity), (ValidationMessage = orElseWith(FormState__getValidation(props.FormState, t, concat(row_7.Id, ..."-quantity")), () => FormState__getValidation(props.FormState, t, concat(row_7.Id, ..."-receiver-stock"))), {
                    ComponentState: componentState,
                    OnChange: (value_2) => {
                        props.Dispatch(new Msg(2, [row_7.Id, value_2]));
                    },
                    TestId: concat("multi-unassign-", row_7.Id, ..."-quantity-input"),
                    ValidationMessage: unwrap(ValidationMessage),
                    Value: unwrap(Value),
                })))]);
        }
    }, "none", "text")), delay(() => append(singleton(new ColumnDefinition$1("unit", "", t("general.unit"), (row_8) => (new CellContent(0, [t(Helper_unitToTranslationKey(row_8.Unit))])), "none", "text")), delay(() => append(singleton(new ColumnDefinition$1("sender", "", t("general.sender"), (row_9) => {
        let matchValue_4, selectedSenderId;
        const matchValue_2 = row_9.Type;
        switch (matchValue_2.tag) {
            case 0:
            case 3:
                return new CellContent(0, [defaultArg(map_1((senderId_1) => defaultArg(map_1((receiver_7) => receiver_7.Name, tryFind((receiver_6) => (receiver_6.Id === senderId_1), props.Receivers)), ""), row_9.CurrentSelectedSenderId), "")]);
            default: {
                const selectableReceiver = map((tupledArg) => {
                    const receiverType = tupledArg[0];
                    const receivers_1 = toArray_1(sortBy((receiver_3) => receiver_3.label.toLowerCase(), map((receiver_2) => {
                        const matchValue_3 = receiver_2.LocationName;
                        if (matchValue_3 != null) {
                            const locationName = matchValue_3;
                            if (equals(receiverType, new ReceiverTypeName(4, []))) {
                                return {
                                    label: concat(locationName, " - ", ...receiver_2.Name),
                                    value: receiver_2,
                                };
                            }
                            else {
                                return {
                                    label: concat(receiver_2.Name, " - ", ...locationName),
                                    value: receiver_2,
                                };
                            }
                        }
                        else {
                            return {
                                label: receiver_2.Name,
                                value: receiver_2,
                            };
                        }
                    }, tupledArg[1]), {
                        Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
                    }));
                    return {
                        label: Helper_receiverTypeNameTranslation(t, receiverType),
                        options: receivers_1,
                    };
                }, List_groupBy((receiver_1) => receiver_1.ReceiverType, choose((senderId) => tryFind((receiver) => (receiver.Id === senderId), props.Receivers), row_9.AvailableSenderIds), {
                    Equals: equals,
                    GetHashCode: (x) => (safeHash(x) | 0),
                }));
                return new CellContent(2, [createElement(GroupedSelect, (($value) => { $value.key = $value.Key; return $value; })({
                    ComponentState: componentState,
                    IsClearable: false,
                    Key: "",
                    NoOptionsMessage: "select.employee_no_options",
                    OnChange: (value_5) => {
                        props.Dispatch(new Msg(9, [row_9.Id, value_5]));
                    },
                    Options: selectableReceiver,
                    PlaceholderKey: "select.employee_placeholder",
                    Value: unwrap((matchValue_4 = row_9.CurrentSelectedSenderId, (matchValue_4 == null) ? undefined : ((selectedSenderId = matchValue_4, map_1((receiver_5) => ({
                        label: receiver_5.Name,
                        value: receiver_5,
                    }), tryFind((receiver_4) => (receiver_4.Id === selectedSenderId), props.Receivers)))))),
                }))]);
            }
        }
    }, "none", "text")), delay(() => append(singleton(new ColumnDefinition$1("receiverStock", "", t("unassign_multiple_tools_dialog.user_stock"), (row_10) => {
        let matchValue_5, matchValue_6, selectedSenderId_1;
        return new CellContent(0, [(matchValue_5 = row_10.Type, (matchValue_5.tag === 0) ? "1" : ((matchValue_5.tag === 3) ? "1" : ((matchValue_5.tag === 1) ? defaultArg(map_1((senderId_2) => {
            const senderValue = tryFind((receiverStock_2) => (receiverStock_2.ReceiverId === senderId_2), props.ToolWithQuantityReceiverStocks);
            if (senderValue == null) {
                return "0";
            }
            else {
                return senderValue.Stock;
            }
        }, row_10.CurrentSelectedSenderId), "0") : ((matchValue_6 = row_10.CurrentSelectedSenderId, (matchValue_6 == null) ? "0" : ((selectedSenderId_1 = matchValue_6, defaultArg(map_1((receiverStock_1) => receiverStock_1.Stock, tryFind((receiverStock) => (receiverStock.ReceiverId === selectedSenderId_1), props.ConsumableReceiverStocks)), "0"))))))))]);
    }, "none", "text")), delay(() => append(singleton(new ColumnDefinition$1("storage", "", t("general.storage"), (row_11) => {
        const matchValue_7 = row_11.Type;
        switch (matchValue_7.tag) {
            case 1:
            case 2: {
                let selectedStorage;
                const matchValue_9 = row_11.SelectedStorageId;
                if (matchValue_9 == null) {
                    selectedStorage = undefined;
                }
                else {
                    const storageId_1 = matchValue_9;
                    selectedStorage = map_1((storage_3) => ({
                        label: Storage__get_DisplayName(storage_3),
                        value: storage_3,
                    }), tryFind((storage_2) => equals(storage_2.Id, new StorageId(parse(storageId_1))), props.Storages));
                }
                return new CellContent(2, [createElement(Select, {
                    ComponentState: componentState,
                    IsClearable: false,
                    NoOptionsMessage: "select.storage_no_options",
                    OnChange: (value_13) => {
                        props.Dispatch(new Msg(3, [row_11.Id, map_1((value_14) => unwrapStorageId(value_14.value.Id), value_13)]));
                    },
                    Options: map((storage_5) => ({
                        label: Storage__get_DisplayName(storage_5),
                        value: storage_5,
                    }), filter((storage_4) => contains(unwrapStorageId(storage_4.Id), row_11.AvailableStorageIds, {
                        Equals: (x_2, y_2) => (x_2 === y_2),
                        GetHashCode: (x_2) => (stringHash(x_2) | 0),
                    }), props.Storages)),
                    PlaceholderKey: "select.storage_placeholder",
                    TestId: concat("multi-unassign-", row_11.Id, ..."-storage-select"),
                    Value: unwrap(selectedStorage),
                })]);
            }
            default: {
                const storageName = (storageId) => defaultArg(map_1(Storage__get_DisplayName, tryFind((storage) => (unwrapStorageId(storage.Id) === storageId), props.Storages)), "");
                const currentStorageName = defaultArg(map_1(storageName, row_11.InitialStorageId), "");
                const matchValue_8 = row_11.SelectedStorageId;
                let matchResult, selectedStorageId_1;
                if (matchValue_8 != null) {
                    if (!equals(row_11.InitialStorageId, matchValue_8)) {
                        matchResult = 0;
                        selectedStorageId_1 = matchValue_8;
                    }
                    else {
                        matchResult = 1;
                    }
                }
                else {
                    matchResult = 1;
                }
                switch (matchResult) {
                    case 0:
                        return new CellContent(0, [concat(currentStorageName, " → ", ...storageName(selectedStorageId_1))]);
                    default:
                        return new CellContent(0, [currentStorageName]);
                }
            }
        }
    }, "none", "text")), delay(() => append(singleton(new ColumnDefinition$1("newState", "", t("general.status"), (row_12) => {
        const matchValue_10 = row_12.Type;
        switch (matchValue_10.tag) {
            case 1:
            case 2:
                return new CellContent(0, [""]);
            default: {
                const stateOptions = ofArray([{
                    label: t("general.active"),
                    value: "active",
                }, {
                    label: t("general.in_maintenance"),
                    value: "inMaintenance",
                }, {
                    label: t("general.retired"),
                    value: "retired",
                }]);
                const selectedValue = flatten(map_1((state) => tryFind((opt) => (opt.value === state), stateOptions), row_12.NewState));
                return new CellContent(2, [createElement(Select, {
                    ComponentState: componentState,
                    IsClearable: true,
                    NoOptionsMessage: "",
                    OnChange: (value_15) => {
                        props.Dispatch(new Msg(8, [row_12.Id, value_15]));
                    },
                    Options: stateOptions,
                    PlaceholderKey: "general.active",
                    TestId: concat("multi-unassign-", row_12.Id, ..."-state-select"),
                    Value: unwrap(selectedValue),
                })]);
            }
        }
    }, "none", "text")), delay(() => singleton(new ColumnDefinition$1("receiverImages", "", t("assignment_notification.receiver_images"), (row_13) => (new CellContent(2, [createElement(ImageUpload, {
        ComponentState: row_13.ImageUploading ? "disabled" : componentState,
        SelectedFiles: row_13.ReceiverImageFiles,
        SetSelectedFile: (files) => {
            props.Dispatch(new Msg(6, [row_13.Id, files]));
        },
    })])), "none", "text"))))))))))))))))))))))))))))));
    const elementTable = (tableKey, rows, onSelected) => {
        let elems, TableRows, Options;
        return reactElement("div", createObj(ofArray([["className", join(" ", ["flex-1", "basis-[36rem]", "min-h-[36rem]", "overflow-hidden"])], (elems = [createElement(InfiniteTable, (TableRows = toArray_1(rows), (Options = {
            BorderStyle: "row",
            CSVDownload: false,
            ConfigurableColumns: false,
            CustomTableFilters: false,
            DefaultSortColumn: ["manufacturer", "asc"],
            Fullscreen: false,
            GlobalSearch: false,
            RowSelection: "singleRow",
            SaveTableConfiguration: false,
            WithQueryParameters: false,
        }, {
            ColumnDefinitions: columnDefinition,
            Controls: singleton_1(new TableControlElement$1(0, [new TableControl$1(t("general.remove"), Recycle_Bin_1(), props.FormState.IsLoading ? undefined : ((rows_1) => {
                iterate((row_14) => {
                    props.Dispatch(onSelected(row_14.Id));
                }, toArray_2(tryHead(rows_1)));
            }), true, false, "tools-dialog-toolreservation-dialog-remove-button")])),
            Options: Options,
            TableKey: tableKey,
            TableRows: TableRows,
        })))], ["children", reactApi.Children.toArray(Array.from(elems))])])));
    };
    return reactElement("div", createObj(ofArray([["className", join(" ", ["mt-4", "flex", "flex-col", "flex-1"])], (elems_2 = toList_1(delay(() => {
        let elems_1, arg_1, arg_3;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "gap-4", "mb-4"])], (elems_1 = [createElement(TabsMenu, {
            Tabs: ofArray([{
                IsSelected: props.IsAddedElementTabVisible,
                Label: containsConsumables ? t("assign_multiple_tools_dialog.consumables") : t("assign_multiple_tools_dialog.tools"),
                OnClick: () => {
                    props.SetIsAddedElementTabVisible(true);
                },
                TestId: "multi-modal-tab-elements",
            }, {
                IsSelected: !props.IsAddedElementTabVisible,
                Label: containsConsumables ? ((arg_1 = {
                    numberOfRemovedTools: length(props.RemovedElements),
                }, i18n.t("assign_multiple_tools_dialog.removed_consumables_elements", arg_1))) : ((arg_3 = {
                    numberOfRemovedTools: length(props.RemovedElements),
                }, i18n.t("assign_multiple_tools_dialog.removed_elements", arg_3))),
                OnClick: () => {
                    props.SetIsAddedElementTabVisible(false);
                },
                TestId: "multi-modal-tab-removed-elements",
            }]),
        })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => (props.IsAddedElementTabVisible ? singleton(elementTable("multi-unassign-elements", props.TableElements, (id) => (new Msg(11, [id])))) : singleton(elementTable("multi-unassign-removed-elements", props.RemovedElements, (id_1) => (new Msg(10, [id_1])))))));
    })), ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

function Form(props) {
    let elems_1, elems, Label_1;
    const t = useTranslation()[0];
    const componentState = props.FormState.IsLoading ? "disabled" : "enabled";
    return reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-4", "mt-4", "w-96"])], (elems_1 = [createElement(TextArea, {
        ComponentState: componentState,
        Label: t("general.comment"),
        OnChange: (value_1) => {
            props.Dispatch(new Msg(1, [value_1]));
        },
        TestId: "multi-unassign-comment-test-id",
        Value: props.Dto.Comment,
    }), reactElement("div", createObj(singleton_1((elems = [createElement(Button, (Label_1 = t("general.save"), {
        ComponentState: (componentState === "disabled") ? "disabled" : (((props.IsTableElementsEmpty ? true : props.HasTableElementEmptyStorageId) ? true : props.HasTableElementEmptySenderId) ? "disabled" : "enabled"),
        Label: Label_1,
        OnClick: () => {
            props.Dispatch(new Msg(0, []));
        },
        TestId: "tools-dialog-toolreservation-save-button",
        Variant: "primary",
    }))], ["children", reactApi.Children.toArray(Array.from(elems))]))))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function Content(props) {
    let elems_8, elems_7;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(true);
    const isAddedElementsTabSelected = patternInput_1[0];
    const patternInput_2 = reactApi.useState(undefined);
    const setMassStorageId = patternInput_2[1];
    const patternInput_3 = reactApi.useState(false);
    const isStorageChangeEnabled = patternInput_3[0];
    const selectedMassStorage = bind((storageId) => map_1((storage_1) => ({
        label: Storage__get_DisplayName(storage_1),
        value: storage_1,
    }), tryFind((storage) => (unwrapStorageId(storage.Id) === storageId), props.RebookableStorages)), patternInput_2[0]);
    return reactElement("div", createObj(ofArray([["className", join(" ", ["h-full", "flex", "flex-col"])], (elems_8 = [reactElement("div", createObj(ofArray([["className", join(" ", ["p-4", "flex", "flex-col", "flex-1"])], (elems_7 = toList_1(delay(() => {
        let elems_6;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "flex-1"])], (elems_6 = toList_1(delay(() => {
            let elems;
            return append(isEmpty(props.Storages) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mb-5"])], (elems = [createElement(WarningAlert, {
                Label: t("multi_operation.unassign.no_storage_access"),
            })], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : empty_1(), delay(() => {
                let elems_1;
                return append(exists(isNotAssigned, props.TableElements) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mb-5"])], ["data-test-id", "multi-unassign-not-assigned-hint"], (elems_1 = [createElement(WarningAlert, {
                    Label: t("multi_operation.unassign.not_assigned_hint"),
                })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))) : empty_1(), delay(() => {
                    let elems_2;
                    return append(exists(isSenderMissing, props.TableElements) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mb-5"])], ["data-test-id", "multi-unassign-sender-missing-hint"], (elems_2 = [createElement(WarningAlert, {
                        Label: t("multi_operation.unassign.sender_missing_hint"),
                    })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))) : empty_1(), delay(() => {
                        let matchValue, validationMessage, elems_3;
                        return append((matchValue = FormState__getValidation(props.FormState, t, "global"), (matchValue == null) ? singleton(defaultOf()) : ((validationMessage = matchValue, singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mb-5"])], (elems_3 = [createElement(ErrorAlert, {
                            Label: validationMessage,
                        })], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))))))), delay(() => append(singleton(createElement(Table, {
                            ConsumableReceiverStocks: props.ConsumableReceiverStocks,
                            Dispatch: props.Dispatch,
                            FormState: props.FormState,
                            IsAddedElementTabVisible: isAddedElementsTabSelected,
                            Receivers: props.Receivers,
                            RemovedElements: props.RemovedElements,
                            SetIsAddedElementTabVisible: patternInput_1[1],
                            Storages: props.Storages,
                            TableElements: props.TableElements,
                            ToolWithQuantityReceiverStocks: props.ToolWithQuantityReceiverStocks,
                        })), delay(() => {
                            let elems_5;
                            return (props.AllowStorageChange && isAddedElementsTabSelected) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mt-6", "flex", "flex-col", "gap-3", "max-w-2xl"])], (elems_5 = toList_1(delay(() => append(singleton(createElement(BlockHeader, {
                                Text: t("multi_operation.unassign.change_storage_title"),
                            })), delay(() => append(singleton(Checkbox({
                                ComponentState: props.FormState.IsLoading ? "disabled" : "enabled",
                                IsChecked: isStorageChangeEnabled,
                                Label: t("multi_operation.unassign.change_storage_checkbox"),
                                OnCheck: (isChecked) => {
                                    patternInput_3[1](isChecked);
                                    if (!isChecked) {
                                        setMassStorageId(undefined);
                                        props.Dispatch(new Msg(5, []));
                                    }
                                },
                                TestId: "multi-unassign-storage-change-checkbox",
                            })), delay(() => (isStorageChangeEnabled ? append(singleton(createElement(InformationAlert, {
                                Label: t("multi_operation.unassign.storage_rebooking_hint"),
                            })), delay(() => {
                                let elems_4;
                                return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["w-96"])], (elems_4 = [createElement(Select, {
                                    ComponentState: props.FormState.IsLoading ? "disabled" : "enabled",
                                    IsClearable: true,
                                    Label: t("multi_operation.unassign.storage_for_all"),
                                    NoOptionsMessage: "select.storage_no_options",
                                    OnChange: (value_17) => {
                                        const storageId_1 = map_1((value_18) => unwrapStorageId(value_18.value.Id), value_17);
                                        setMassStorageId(storageId_1);
                                        props.Dispatch(new Msg(4, [storageId_1]));
                                    },
                                    Options: map((storage_2) => ({
                                        label: Storage__get_DisplayName(storage_2),
                                        value: storage_2,
                                    }), props.RebookableStorages),
                                    PlaceholderKey: "select.storage_placeholder",
                                    TestId: "multi-unassign-storage-for-all-select",
                                    Value: unwrap(selectedMassStorage),
                                })], ["children", reactApi.Children.toArray(Array.from(elems_4))])]))));
                            })) : empty_1()))))))), ["children", reactApi.Children.toArray(Array.from(elems_5))])])))) : empty_1();
                        }))));
                    }));
                }));
            }));
        })), ["children", reactApi.Children.toArray(Array.from(elems_6))])])))), delay(() => {
            let IsTableElementsEmpty, HasTableElementEmptyStorageId;
            return isAddedElementsTabSelected ? singleton(createElement(Form, (IsTableElementsEmpty = isEmpty(props.TableElements), (HasTableElementEmptyStorageId = exists((tableElement_2) => (tableElement_2.SelectedStorageId == null), props.TableElements), {
                Dispatch: props.Dispatch,
                Dto: props.Dto,
                FormState: props.FormState,
                HasTableElementEmptySenderId: exists((tableElement_3) => (tableElement_3.CurrentSelectedSenderId == null), props.TableElements),
                HasTableElementEmptyStorageId: HasTableElementEmptyStorageId,
                IsTableElementsEmpty: IsTableElementsEmpty,
                Receivers: props.Receivers,
            })))) : empty_1();
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_7))])])))], ["children", reactApi.Children.toArray(Array.from(elems_8))])])));
}

export function MultiUnassignModalSheet(props) {
    let elems, matchValue, matchValue_1, matchValue_2, matchValue_3, matchValue_4;
    const permissions = usePermissions();
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => {
        const tupledArg = init(props.SuccessCallback, props.OnClose, props.UserData, permissions, props.SenderId, props.AllowStorageChange, props.UnassignProps);
        return whenOpen(props.IsOpen, tupledArg[0], tupledArg[1]);
    }, update, (_arg_1, _arg_1_1) => {
    }), undefined, [props.IsOpen]);
    const state_2 = patternInput[0];
    const patternInput_1 = useTranslation();
    return reactElement("div", createObj(singleton_1((elems = [createElement(ModalSheet, {
        CloseButtonTestId: "",
        Content: (matchValue = state_2.Receivers, (matchValue_1 = state_2.Consumables, (matchValue_2 = state_2.Sets, (matchValue_3 = state_2.Tools, (matchValue_4 = state_2.Storages, (matchValue.tag === 0) ? createElement(Skeleton, {
            Variant: "table",
        }) : ((matchValue_1.tag === 0) ? createElement(Skeleton, {
            Variant: "table",
        }) : ((matchValue_2.tag === 0) ? createElement(Skeleton, {
            Variant: "table",
        }) : ((matchValue_3.tag === 0) ? createElement(Skeleton, {
            Variant: "table",
        }) : ((matchValue_4.tag === 0) ? createElement(Skeleton, {
            Variant: "table",
        }) : createElement(Content, {
            AllowStorageChange: state_2.AllowStorageChange,
            ConsumableReceiverStocks: state_2.ConsumableReceiverStocks,
            Dispatch: patternInput[1],
            Dto: state_2.Dto,
            FormState: state_2.FormState,
            RebookableStorages: rebookableStorages(state_2.Permissions, state_2.UserData.UserId, matchValue_4.fields[0]),
            Receivers: matchValue.fields[0],
            RemovedElements: state_2.RemovedElements,
            Storages: matchValue_4.fields[0],
            TableElements: state_2.TableElements,
            ToolWithQuantityReceiverStocks: state_2.ToolWithQuantityReceiverStocks,
        })))))))))),
        Controls: empty(),
        IsModalOpen: props.IsOpen,
        OnClose: props.OnClose,
        Title: patternInput_1[0]("general.take_back"),
    })], ["children", reactApi.Children.toArray(Array.from(elems))]))));
}

